export const CUSTOMER_HIDE_NAVBAR_PREFIXES = [
  "/dashboard",
  "/marketplace",
  "/notifications",
  "/messenger",
  "/my-bookings",
  "/subscription",
  "/profile",
  "/hourly",
  "/elder-profile",
  "/care-team",
  "/my-agreement",
  "/care-logs",
  "/call-history",
  "/payments",
  "/payment-history",
  "/my-care-manager",
  "/support",
  "/settings",
  "/carehub",
];

export const CUSTOMER_TOP_NAV_ITEMS = [
  { to: "/dashboard", label: "Dashboard", end: true, icon: "grid", navKey: "dashboard" },
  { to: "/marketplace", label: "Caregivers", icon: "search" },
  { to: "/my-bookings", label: "Bookings", icon: "clock" },
  { to: "/subscription", label: "Billing & Care Passes", icon: "wallet", navKey: "billing" },
  { to: "/care-logs", label: "Reports", icon: "chart" },
  { to: "/call-history", label: "Call history", icon: "clock" },
];

export const CUSTOMER_SIDEBAR_ITEMS = [
  { to: "/dashboard", label: "Dashboard", end: true, icon: "home" },
  { to: "/marketplace", label: "Find caregivers", icon: "search" },
  { to: "/my-bookings", label: "My bookings", icon: "clock" },
  { to: "/subscription", label: "Billing & Care Passes", icon: "shield" },
  { to: "/payment-history", label: "Payments", icon: "rupee" },
  { to: "/payments", label: "Wallet & Credits", icon: "wallet" },
  { to: "/elder-profile", label: "Patients", icon: "user" },
  { to: "/care-team", label: "Care Team", icon: "users" },
  { to: "/my-care-manager", label: "Care Manager", icon: "shield" },
  { to: "/care-logs", label: "Care logs", icon: "chart" },
  { to: "/call-history", label: "Call history", icon: "clock" },
  { to: "/support", label: "Support Center", icon: "help" },
  { to: "/settings", label: "Settings", icon: "settings" },
];
